import React from "react";
import styles from "./index.module.scss";

export interface PageFooterProps {}

const PageFooter: React.FC<PageFooterProps> = (props) => {
  const getContent = (item: {
    type: "text" | "image";
    content: string;
    url?: string;
    options?: any;
  }) => {
    if (item.type === "text") {
      return <span>{item.content}</span>;
    } else if (item.type === "image") {
      return (
        <img
          src={item.content}
          alt=""
          style={{ width: item.options?.width, height: item.options?.height }}
        />
      );
    }

    return null;
  };

  return (
    <footer className={styles.page_footer}>
      <div className={styles.footer_wrapper}>
        <div className={styles.column_list}>
          {columns.map((column, idx) => (
            <ul key={idx}>
              <li className={styles.column_title}>{column.title}</li>
              {column.list.map((item, idx) => (
                <li key={idx} className={styles.column_row_item}>
                  {getContent(item)}
                </li>
              ))}
            </ul>
          ))}
        </div>

        <div className={styles.horizontal_nav}>
          <img src="/company_logo.png" alt="" />

          {navs.map((item, idx) => (
            <span
              className={styles.nav_item}
              key={idx}
              onClick={() => {
                window.open(item.url, "blank");
              }}
            >
              {item.title}
            </span>
          ))}
        </div>

        <p className={styles.base_info}>隐私权政策 · 使用条款 · 网站问题反馈</p>

        <p className={styles.base_info}>
          Copyright @ 2022 宝略科技 宝略科技（浙江）有限公司版权所有 2019
          PopSmart Technology Co., Ltd. All Rights Reserved |
          浙ICP备17033777号-1
        </p>
      </div>
    </footer>
  );
};

export default PageFooter;

const navs = [
  {
    title: "宝略官网",
    url: "https://www.popsmart.cn",
  },
  {
    title: "招聘精英",
    url: "https://www.popsmart.cn",
  },
  {
    title: "市场合作",
    url: "https://www.popsmart.cn",
  },
  {
    title: "联系我们",
    url: "https://www.popsmart.cn",
  },
];

const columns: {
  title: string;
  list: {
    type: "text" | "image";
    content: string;
    url?: string;
    options?: any;
  }[];
}[] = [
  {
    title: "产品中心",
    list: [
      {
        type: "text",
        content: "基础版",
      },
      {
        type: "text",
        content: "进阶版",
      },
      {
        type: "text",
        content: "高级版",
      },
    ],
  },
  {
    title: "组件商城",
    list: [
      {
        type: "text",
        content: "免费",
      },
      {
        type: "text",
        content: "收费",
      },
    ],
  },
  {
    title: "帮助与支持",
    list: [
      {
        type: "text",
        content: "快速入门",
      },
      {
        type: "text",
        content: "帮助中心",
      },
      {
        type: "text",
        content: "售后服务政策",
      },
      {
        type: "text",
        content: "下载中心",
      },
      {
        type: "text",
        content: "安全与隐私",
      },
    ],
  },
  {
    title: "探索宝略",
    list: [
      {
        type: "text",
        content: "关于我们",
      },
      {
        type: "text",
        content: "自研核心产品 ",
      },
      {
        type: "text",
        content: "自研硬件产品",
      },
      {
        type: "text",
        content: "数字孪生服务",
      },
      {
        type: "text",
        content: "行业解决方案",
      },
    ],
  },
  {
    title: "联系我们",
    list: [
      {
        type: "text",
        content: "Tel: 0574-55123976",
      },
      {
        type: "text",
        content: "Web: www.popsmart.cn",
      },
      {
        type: "image",
        content: "/imgs/qr-code.png",
        options: {
          width: 83,
          height: 83,
        },
      },
    ],
  },
];
